import _ from 'underscore';
import Promise from 'bluebird';
import { PermissionUtils } from '@bingads-webui-clientcenter/entity-utils';
import { NumberUtils } from '@bingads-webui-clientcenter/common-utils';

const { isValidWholeNumber } = NumberUtils;

/**
 * Get account permission on given actions by calling /API/Permission/Account
 * @function
 * @param {object} jsDataCcRest jsData object
 * @param {object} options options\
 * @param {Boolean} options.params optional params, e.g. { params: { cid } } for calls in support pages
 * @param {String|Number} options.accountId The account id
 * @param {String|Number} options.customerId The customer id required to check account permission, for example, checking
 *    PaymentInstrumentAction requires account's billToCustomerId. No need to pass in it if no customer id is required to
 *    check account permission.
 * @param {Array<String>} options.securityActions List of actions
 * @returns {Promise<Object>} An object with { actionName : value } where value is a boolean indication if the actionName is authorized or not
 */
export const getAccountPermission = (jsDataCcRest, {
  accountId, customerId, securityActions, params = {},
}) => {
  if (isValidWholeNumber(accountId) && !_.isEmpty(securityActions)) {
    return jsDataCcRest.PermissionAccount.findAll({ accountId, customerId, securityActions }, params)
      .then(permissions => PermissionUtils.getPermissionMap(permissions));
  }

  return Promise.resolve({});
};

/**
 * Get current user's permission on customer actions by calling /API/Permission/Customer
 * @function
 * @param {object} jsDataCcRest jsData object
 * @param {object} options options
 * @param {String|Number} options.customerId The customer id
 * @param {Array<String>} options.securityActions List of actions
 * @returns {Promise<Object>} An object with { actionName : value } where value is a boolean indication if the actionName is authorized or not
 */
export const getCustomerPermission = (jsDataCcRest, { customerId, securityActions }) => {
  if (isValidWholeNumber(customerId) && !_.isEmpty(securityActions)) {
    return jsDataCcRest.PermissionCustomer.findAll({ customerId, securityActions })
      .then(permissions => PermissionUtils.getPermissionMap(permissions));
  }

  return Promise.resolve({});
};
